import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "login-background",
    style: {
      'background-image': 'url(' + _vm.backgroundUrl + ')'
    }
  }, [_c('a-card', {
    staticClass: "login-box"
  }, [_c('h3', {
    staticClass: "login-box-title"
  }, [_vm._v(_vm._s(_vm.t('欢迎使用谷仓海外仓系统')))]), _c('tip'), _c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formDataRule
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('a-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('账号')
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleEnter($event);
      }
    },
    model: {
      value: _vm.formData.account,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "account", $$v);
      },
      expression: "formData.account"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "prefix",
      "type": "user"
    },
    slot: "prefix"
  })], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('a-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "type": "password",
      "size": "large",
      "placeholder": _vm.t('请输入密码')
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleEnter($event);
      }
    },
    model: {
      value: _vm.formData.password,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "password", $$v);
      },
      expression: "formData.password"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "prefix",
      "type": "lock"
    },
    slot: "prefix"
  })], 1)], 1), _vm.showCaptcha ? _c('a-form-model-item', {
    attrs: {
      "prop": "image_validation_code"
    }
  }, [_c('a-input-group', {
    attrs: {
      "compact": ""
    }
  }, [_c('a-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('请输入验证码')
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleEnter($event);
      }
    },
    model: {
      value: _vm.formData.image_validation_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "image_validation_code", $$v);
      },
      expression: "formData.image_validation_code"
    }
  }), _c('a-spin', {
    staticClass: "login-validate-code",
    attrs: {
      "spinning": _vm.validateCodeImageLoading
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.validateCodeImageUrl,
      "data-permission": "login_image_validation_code",
      "id": "login_image_validation_code"
    },
    on: {
      "click": _vm.handleSwitchImageValidateCode
    }
  })])], 1)], 1) : _vm._e(), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "-15px"
    }
  }, [_c('a', {
    attrs: {
      "href": "/forget_password",
      "data-permission": "login_forget_password",
      "id": "login_forget_password",
      "target": "_blank",
      "fbu-analyse-name": $t("\u5FD8\u8BB0\u5BC6\u7801?")
    }
  }, [_c('a-button', {
    attrs: {
      "type": "link",
      "fbu-analyse-name": $t("\u5FD8\u8BB0\u5BC6\u7801?")
    }
  }, [_vm._v(_vm._s(_vm.t('忘记密码?')))])], 1)]), _c('a-button', {
    staticClass: "margin-top",
    attrs: {
      "size": "large",
      "data-permission": "login_submit",
      "id": "login_submit",
      "type": "primary",
      "loading": _vm.loginLoading,
      "block": "",
      "fbu-analyse-name": $t("\u767B\u5F55")
    },
    on: {
      "click": _vm.handleLogin
    }
  }, [_vm._v(_vm._s(_vm.t('登录')))])], 1)], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };